var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedInIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "#0A66C2",
  rx: 17
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.48 23.8v-9.176h-3.097V23.8zm-1.548-10.43c1.08 0 1.753-.704 1.753-1.584-.02-.9-.673-1.586-1.732-1.586-1.06 0-1.753.685-1.753 1.586 0 .88.672 1.585 1.712 1.585zM15.195 23.8h3.097v-5.124c0-.275.02-.549.102-.745.224-.548.734-1.115 1.59-1.115 1.12 0 1.569.841 1.569 2.075V23.8h3.097v-5.262c0-2.818-1.528-4.13-3.566-4.13-1.671 0-2.405.92-2.812 1.547h.02v-1.331h-3.097c.04.86 0 9.176 0 9.176"
}))));
export default SvgLinkedInIcon;